import { defineStyle } from "@chakra-ui/react";
import { mode } from "@chakra-ui/theme-tools";

const Button = {
  baseStyle: {
    borderRadius: "sm", 
  },
  defaultProps: {
    variant: "primary",
    colorScheme: "primary",
  },
  variants: {
    "primary": defineStyle((props) => ({
      color: "base.500",
      backgroundColor: mode("primary.500", "primary.400")(props),
      _hover: {
        backgroundColor: mode("primary.600", "primary.500")(props),
        _disabled: {
          backgroundColor: "primary.600",
        }
      },
      _disabled: {
        backgroundColor: "primary.600",
      },
    })),
    "primary-outline": defineStyle((props) => ({
      color:  mode("primary.600", "primary.400")(props),
      border: "1px solid",
      borderColor:  mode("primary.600", "primary.400")(props),
      _hover: {
        backgroundColor: "primary.200a",
      }
    })),
    "primary-soft-outline": defineStyle((props) => ({
      color:  mode("primary.600", "primary.400")(props),
      border: "1px solid",
      borderColor:  "primary.300a",
      _hover: {
        backgroundColor: "primary.100a",
      }
    })),
    "primary-text": defineStyle((props) => ({
      color:  mode("primary.700", "primary.400")(props),
      _hover: {
        backgroundColor: "primary.100a",
      }
    })),
    "secondary": defineStyle((props) => ({
      color: "base.500",
      backgroundColor: mode("secondary.500", "secondary.400")(props),
      _hover: {
        backgroundColor: mode("secondary.600", "secondary.500")(props),
        _disabled: {
          backgroundColor: "secondary.600",
        }
      },
      _disabled: {
        backgroundColor: "secondary.600",
      },
    })),
    "secondary-outline": defineStyle((props) => ({
      color:  mode("secondary.700", "secondary.400")(props),
      border: "1px solid",
      borderColor:  mode("secondary.700", "secondary.400")(props),
      _hover: {
        backgroundColor: "secondary.200a",
        color:  mode("secondary.600", "secondary.500")(props),
        borderColor:  mode("secondary.600", "secondary.500")(props),
      }
    })),
    "secondary-soft-outline": defineStyle((props) => ({
      color:  mode("secondary.600", "secondary.300")(props),
      border: "1px solid",
      borderColor:  mode("secondary.600", "secondary.300")(props),
      _hover: {
        backgroundColor: "secondary.100a",
      }
    })),
    "secondary-text": defineStyle((props) => ({
      color:  mode("secondary.700", "secondary.400")(props),
      _hover: {
        backgroundColor: "secondary.100a",
      }
    })),
    "base": defineStyle((props) => ({
      color: mode("white", "base.500")(props),
      backgroundColor: mode("base.500", "white")(props),
      _hover: {
        backgroundColor: mode("base.500a", "whiteAlpha.900")(props),
        _disabled: {
          backgroundColor: mode("base.500a", "whiteAlpha.900")(props),
        }
      },
      _disabled: {
        backgroundColor: mode("base.500a", "whiteAlpha.900")(props),
      }
    })),
    "base-outline": defineStyle((props) => ({
      color: mode("base.500", "white")(props),
      border: "1px solid",
      borderColor: mode("base.500a", "whiteAlpha.900")(props),
      _hover: {
        backgroundColor: mode("base.200a", "base.500a")(props),
      }
    })),
    "base-soft-outline": defineStyle((props) => ({
      color: mode("base.500", "white")(props),
      border: "1px solid",
      borderColor: mode("base.300a", "whiteAlpha.300")(props),
      _hover: {
        backgroundColor: mode("base.100a", "base.500a")(props),
      }
    })),
    "base-text": defineStyle((props) => ({
      color: mode("base.500", "whiteAlpha.900")(props),
      _hover: {
        backgroundColor: mode("base.100a", "base.500a")(props),
      }
    }))
  },
  sizes: {
    xl: {
      h: 12,
      fontSize: "xl",
      px: 8,
    },
    lg: {
      h: 10,
    },
    md: {
      h: 8,
    },
    sm: {
      h: 7,
    },
    xs: {
      h: 6,
    },
  },
};

export default Button;
